{
  "title": "Ops view",
  "loading": "Loading the ops…",
  "needEntryTitle": "You need to join first",
  "needEntryBody": "This screen is only for alliance members who have joined. Come in with the shared join code and your game ID, and this ops shows up here.",
  "needEntryCta": "Go to join screen",
  "waitingTitle": "No ops confirmed yet",
  "waitingBody": "When the CT confirms the ops, the rally list shows up here. Just leave this screen open. It arrives without a refresh.",
  "pickTitle": "Pick what to listen to",
  "pickBody": "Tap your own rally in the list below and its name and countdown appear here.",
  "pickWhy": "The screen does not pick for you. If you run several accounts, the ID you joined with can differ from the spot you hold in this ops, and a pick made for you would be the wrong one.",
  "listenLabel": "Listen",
  "listeningLabel": "Listening",
  "stopLabel": "Stop",
  "highlightLabel": "Watch",
  "highlightOnLabel": "Watching",
  "listTitle": "Rallies in this ops",
  "listCount": "Rallies: {n}",
  "columnOpen": "Opens in",
  "openPassed": "Since open",
  "columnOpened": "Opened",
  "columnImpact": "Impact",
  "columnOffset": "vs main",
  "rosterGone": "Off the roster list",
  "progressLabel": "March progress from start to impact",
  "soundOne": "Sound plays for the one you picked. You can watch several, but only one of them makes sound.",
  "lockedTitle": "Sound is still locked",
  "armLabel": "Turn sound on",
  "muteLabel": "Mute",
  "unmuteLabel": "Unmute",
  "mutedTitle": "Sound is off",
  "mutedBody": "The numbers on screen keep running. Turn it back on and the signal rings from that point. Opens that passed while it was off are not counted as missed.",
  "mutedBodyPassed": "The numbers on screen keep running. This rally's open has passed. Pick another rally and turn sound back on to hear it there. Opens that passed while it was off are not counted as missed.",
  "missedTitle": "This open has passed",
  "missedBody": "No sound will play. If you treat a late signal as the open, you press even later than you already are.",
  "passedBody": "The sound rang on time. This open is done, and picking another rally moves the signal there.",
  "passedBodyMuted": "The sound rang on time. This open is done. Pick another rally and turn sound back on to move the signal there.",
  "offAtOpenBody": "Sound was off at the open. Pick another rally to hear it there.",
  "appMissedBody": "The sound could not play on time. Pick another rally to hear it there.",
  "appMissedBodyMuted": "The sound could not play on time. Pick another rally and turn sound back on to hear it there.",
  "audioSuspended": "Audio is locked. The browser plays no sound until you tap the screen once. Tap the button right below to unlock it. On an iPhone, also check the silent switch on the side.",
  "audioClosed": "Audio was closed. Reload the page.",
  "audioNotRunning": "Audio is not running ({state}).",
  "droppedMarkers": "{n} beat(s) were already past and were not set again. The remaining beats and the start tone still ring on time.",
  "selectionLocal": "What you pick stays on this screen only. Nobody else's screen changes.",
  "signalNoAudio": "This browser has no way to play sound. Follow the numbers on screen instead."
}
